import { camelizeKeys } from '@get-bridge/bridge-string-utils'
import { apiClient } from '../api-client'

export function fetchAccount(session) {
  const url = session
    ? `/api/learner/sub_account?as_user_id=${session.user.id}`
    : '/api/guest_learner/sub_account?as_user_id='
  return apiClient(url).then(camelizeKeys)
}
